import React from "react";
import {autobind} from "core-decorators";
import {Button, message, Popconfirm, Tooltip} from "antd";
import {FaTrash} from "react-icons/fa";
import {runInAction} from "mobx";
import {inject, observer} from "mobx-react";
import {gql} from "@apollo/client";

import "./InvitationActions.scss";
import {EnsembleUsersQuery, DeleteUserInvitation, DeleteUserInvitationVariables} from "@/graphql/types";
import Store from "@/stores";

export interface IInvitationActionsProps {
  userInvitation: EnsembleUsersQuery["user_invitations"][0];
  userInvitations: EnsembleUsersQuery["user_invitations"];
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class InvitationActions extends React.Component<IInvitationActionsProps> {
  async remove() {
    const {userInvitation, userInvitations} = this.props;
    const userInvitationIdx = userInvitations.indexOf(userInvitation);
    runInAction(() => userInvitations.splice(userInvitationIdx, 1)); // optimistic UI update
    try {
      const result = await this.props.store!.apollo.client.mutate<DeleteUserInvitation, DeleteUserInvitationVariables>({
        mutation: gql`
          mutation DeleteUserInvitation($userInvitationId: uuid!) {
            user_invitation: delete_user_invitations_by_pk(id: $userInvitationId) {
              id
            }
          }
        `,
        variables: {userInvitationId: userInvitation.id},
      });
      const deletedUserInvitation = result.data?.user_invitation;
      if (!deletedUserInvitation) throw new Error("Could not delete user invitation");
    } catch (error) {
      runInAction(() => userInvitations.splice(userInvitationIdx, 0, userInvitation));
      console.error(error);
      message.error("Oops! Error when removing invitation");
    }
  }

  public render() {
    return (
      <div className="UserActions">
        <Tooltip placement="topLeft" arrowPointAtCenter title="Remove">
          <Popconfirm
            title="Are you sure you want to remove this invitation?"
            placement="topRight"
            arrowPointAtCenter
            onConfirm={this.remove}
          >
            <Button type="link" shape="circle" size="small">
              <FaTrash />
            </Button>
          </Popconfirm>
        </Tooltip>
      </div>
    );
  }
}
